// 费用结转管理
const CostCarry = () => import('../pages/CostCarryManagement/CostCarry.vue');
const CostDetailed = () => import('../pages/CostCarryManagement/CostDetailed.vue');
const CostRecord = () => import('../pages/CostCarryManagement/CostRecord.vue');

export default [
	{
		path: '/CostCarry',
		component: CostCarry,
		name: 'CostCarry',
	},
	{
		path: '/CostDetailed',
		component: CostDetailed,
		name: 'CostDetailed',
	},
	{
		path: '/CostRecord',
		component: CostRecord,
		name: 'CostRecord',
	},
];
